import { Component, input, output } from "@angular/core";
import DataSource from "devextreme/data/data_source";

@Component({
  selector: "pms-page-datagrid-toolbar-select",
  template: "",
  standalone: false
})
export class PageDatagridToolbarSelectComponent {
  protected readonly component = "dxSelectBox";

  placeholder = input.required<string>();

  classList = input<string>("");

  hidden = input<boolean>(false);

  dataSource = input.required<
    DataSource<{
      value: string;
      display: string;
      [key: string]: unknown;
    }>
  >();

  onValueChanged = output<any>();
}
